/* eslint-disable no-mixed-operators */

export default (timestamp, lengthLimit = null) => {
  if (!timestamp) {
    return null;
  }

  let now = new Date().getTime();
  if (lengthLimit) {
    now = now.toString().substr(0, lengthLimit);
    now = parseInt(now, 10);
  }

  return Math.floor((now - timestamp) / 1000);
};
